(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-search-promos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ds-search-promos')) {
    customElements.define('ds-search-promos', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ds-search-promos__slide'));
        this.index = 0;
        this.button = this.querySelector('[data-promo-pause]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        if (this.slides.length < 2) return;
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.syncButton();
        }, options);
        this.motion.addEventListener('change', event => {
          this.paused = event.matches;
          this.syncButton();
        }, options);
        this.syncButton();
        this.timer = window.setInterval(() => {
          const drawer = this.closest('drawer-component');
          const input = drawer?.querySelector('input[type="search"]');
          if (this.paused || document.hidden || this.matches(':hover') || this.contains(document.activeElement) || drawer?.getAttribute('aria-hidden') !== 'false' || input?.value.trim() || !this.getClientRects().length) return;
          this.slides[this.index].hidden = true;
          this.index = (this.index + 1) % this.slides.length;
          this.slides[this.index].hidden = false;
        }, Number(this.dataset.delay) || 5000);
      }
      syncButton() {
        this.button.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-ds-variant-direction]');
  if (!button) return;
  const scroller = button.closest('.ds-variant-carousel-controls')?.nextElementSibling;
  if (!scroller?.classList.contains('ds-variant-carousel')) return;
  const firstCard = scroller.querySelector('.ds-variant-thumbnail-button');
  const step = (firstCard?.getBoundingClientRect().width || 134) + 12;
  scroller.scrollBy({left: step * Number(button.dataset.dsVariantDirection), behavior: 'smooth'});
});

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  const label = input.nextElementSibling;
  if (label?.classList.contains('ds-variant-thumbnail-button')) {
    label.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'auto'});
  }
});
  } catch(e) { console.error(e); }
})();

})();
